import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import useNavigation from '../../../hook/useNavigation';
import Loyality from '../Loyality';
import { isEmptyData } from '../../../utils/helper';
import { useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Profile from '../Profile';
import useLoyalty from '../../hook/useLoyalty';
import { USER_STATUS } from '../../../utils/constants';

const Info = (props) => {
	const { onClick } = props;
	const user = useSelector((store) => store?.user);
	const phoneNumber = user?.primary_phone ? user?.primary_phone.slice(0, 8) + '****' : '';

	return (
		<>
			<div className='flex h-12 items-center px-4' onClick={onClick}>
				<div className='text-gray-700 font-semibold text-xs'>Hi, {phoneNumber}</div>
				<ChevronRightIcon className='h-3.5 w-auto font-bold text-gray-700 pl-1' />
			</div>
		</>
	);
};

const Member = () => {
	const navigate = useNavigation();
	const user = useSelector((store) => store?.user);
	const isLogin = !isEmptyData(user?.token) && user?.status === USER_STATUS.ACTIVE;
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const { isLoading: isLoadingLoyalty, loyalty, tier: tierConfig, config: clientConfig, isProfileCompleted, loyaltyVouchers, tokenProfile, hidden } = useLoyalty();

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		if (!isLogin) return;
		setIsShowBottomSheet(true);
	};

	const profileProps = {
		onClose: handleCloseBottomSheet,
    loyalty,
		isLoading: isLoadingLoyalty,
		isProfileCompleted,
		tierConfig,
		clientConfig,
    loyaltyVouchers,
    tokenProfile,
    isLogin,
	};

	const loyaltyProps = {
		loyalty,
		isLoading: isLoadingLoyalty,
		isProfileCompleted,
		tierConfig,
		clientConfig,
    loyaltyVouchers,
    tokenProfile,
    isLogin,
    hidden,
	};

	const infoProps = {
		onClick: handleClick,
	};

	return (
		<>
			<Loyality {...loyaltyProps} />
			{!isLogin ? (
				<>
					<div className='flex h-12 items-center px-4' onClick={() => navigate.push('/ufood-x/login')}>
						<div className='text-gray-700 font-semibold text-xs'>Login to see more benefit and rewards</div>
						<ChevronRightIcon className='h-3.5 w-auto font-bold text-gray-700 pl-1' />
					</div>
				</>
			) : (
				<>
					<Info {...infoProps} />
				</>
			)}
			<div className='border-t-1 border-solid border-gray-200' />
			<BottomSheet
				key={'my-profile'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				header={false}
				snapPoints={({ maxHeight }) => {
					return [maxHeight, maxHeight];
				}}>
				<Profile {...profileProps} />
			</BottomSheet>
		</>
	);
};
export default Member;
